module.exports = __webpack_public_path__ + "static/checkset3-4ad88815c57ae389c9ca9ecb7ad12c46.jpeg";